import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

import { EmployeeStatus, Namespace } from '../enums';

export const useEmployeeStatuses = () => {
  const { t } = useTranslation(Namespace.EmployeeStatuses);

  return useMemo(
    () => [
      {
        label: t(EmployeeStatus.Employee),
        value: EmployeeStatus.Employee,
      },
      {
        label: t(EmployeeStatus.Evaluation),
        value: EmployeeStatus.Evaluation,
      },
      {
        label: t(EmployeeStatus.Dismissed),
        value: EmployeeStatus.Dismissed,
      },
      {
        label: t(EmployeeStatus.Freelancer),
        value: EmployeeStatus.Freelancer,
      },
      {
        label: t(EmployeeStatus.Registered),
        value: EmployeeStatus.Registered,
      },
    ],
    [t],
  );
};
